import script from "./fw37_dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./fw37_dashboard.vue?vue&type=script&setup=true&lang=js"

import "./fw37_dashboard.vue?vue&type=style&index=0&id=9ca948ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ca948ea"]])

export default __exports__